module.exports = __webpack_public_path__ + "a42700d9739796afc2f4f0948750ae3a.pdf";